import Modal from 'react-modal';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    padding: 0,
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

import { useEnableDisableCoordinatorMutation } from '@/generated/graphql';
import { ICoordinatorTable } from '@/shared/interfaces';

import { Box, Button, Divider, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { AiOutlineExclamationCircle } from 'react-icons/ai';

interface ICoordinatorProp {
  datas: ICoordinatorTable | undefined;
  isOpen: boolean;
  openEvent: (open: boolean) => void;
  refetchData: () => void;
}

export function EnableDisableCoordinator(props: ICoordinatorProp) {
  const { datas, isOpen, openEvent, refetchData } = props;

  const [enableDisableCoordinatorMutation] = useEnableDisableCoordinatorMutation();

  const handleClose = () => openEvent(false);

  const toggle = (trigger: boolean) => {
    enableDisableCoordinatorMutation({
      variables: {
        input: {
          id: datas?.id ?? '',
          isDisabled: trigger,
        },
      },
      onCompleted() {
        refetchData();
      },
    });

    handleClose();
  };

  return (
    <>
      <Modal isOpen={isOpen} onRequestClose={handleClose} style={customStyles} contentLabel="Example Modal">
        <Box sx={{ width: 500, py: 5, background: '#fff' }}>
          <Box justifyContent={'center'} display={'flex'} mb={3}>
            <AiOutlineExclamationCircle size={90} color={'#facea8'} />
          </Box>
          <Typography variant="h5" gutterBottom component="div" fontSize={30} fontWeight={600} textAlign={'center'}>
            Are you sure ?
          </Typography>

          <Typography variant="body1" gutterBottom textAlign={'center'}>
            {datas?.isDisabled ? <>You want to enable this Coordinator?</> : <>You want to disable this Coordinator?</>}
          </Typography>
          <Box justifyContent={'center'} display={'flex'} mt={5}>
            <Button
              variant="contained"
              sx={{ mr: 3, background: '#427FC1' }}
              onClick={() => {
                toggle(!datas?.isDisabled);
              }}>
              Yes
            </Button>
            <Button variant="contained" sx={{ mr: 3, background: '#B44F4F' }}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
